import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import axios from "../../axios/axios";
import Layout from "./Layout";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import stripHtml from "../../utils/stripHtml";

const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["blockquote"],
    ["link", "image"],
    ["clean"],
  ],
};

const AddBlogs = () => {
  const [errorMessage, seterrorMessage] = useState("");
  const [file, setFile] = useState(null);

  const onFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const [blog, setBlog] = useState({
    title: "",
    description: "",
    service: "",
  });

  const blogHandler = (e) => {
    const { name, value } = e.target;
    setBlog({ ...blog, [name]: value });
  };

  const descriptionHandler = (value) => {
    setBlog((prev) => ({ ...prev, description: value }));
  };

  const addBlog = async (e) => {
    e.preventDefault();
    if (stripHtml(blog.description).length < 600) {
      toast.error("Description must be at least 600 characters long.");
      return;
    }
    const formData = new FormData();
    formData.append("title", blog.title);
    formData.append("description", blog.description);
    formData.append("service", blog.service);
    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await axios.post("/blog", formData);
      const data = response.data;
      if (data) {
        toast.success("Blog Added");
      }
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };
  return (
    <>
      <Navbar />
      <Layout>
        <div className=" py-5 h-100 bg-light">
          <div className="col-md-7 container">
            <form onSubmit={addBlog}>
              <h3 className="text-center fw-bold prata-regular mb-4">
                Add Blog
              </h3>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <div class="mb-3">
                <input
                  onChange={blogHandler}
                  name="title"
                  value={blog.title}
                  type="text"
                  placeholder="Title *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>

              <div className="mb-3">
                <input
                  onChange={onFileChange}
                  type="file"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>

              <div class="mb-3 bg-white">
                <ReactQuill
                  theme="snow"
                  value={blog.description}
                  onChange={descriptionHandler}
                  modules={quillModules}
                  placeholder="Description *"
                  style={{ height: "350px", marginBottom: "42px" }}
                />
              </div>
              <div className="mb-3">
                <select
                  onChange={blogHandler}
                  name="service"
                  value={blog.service}
                  className="form-select w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                >
                  <option value="">Select Service</option>
                  <option value="Color Correction">Color Correction</option>
                  <option value="Culling">Culling</option>
                  <option value="Video Editing">Video Editing</option>
                  <option value="Album Design">Album Design</option>
                  <option value="Real Estate">Real Estate</option>
                  <option value="Retouching">Retouching</option>
                </select>
              </div>

              <button
                type="submit"
                name="submit"
                class="btn bg_maincolor text-light"
              >
                Add Blog
              </button>
            </form>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default AddBlogs;
